import { z } from '@bonanza-social/toolkit/api';

export const CashbackRewardType = z.enum(['Cash', 'Bonus']);

export const CashbackRewardSchema = z.object({
  amount: z.number(),
  maxAmount: z.number(),
  type: CashbackRewardType,
});

export const CashbackPromotionSchema = z.object({
  id: z.number(),
  endDate: z.string().datetime(),
  rewards: z.array(CashbackRewardSchema),
});

export const CashbackResponseSchema = z.object({
  promotions: z.array(CashbackPromotionSchema),
});
